<div class="body">
    <div class="loader-container">
    <div class="ring"></div>
    <div class="ring"></div>
    <div class="ring"></div>
    <img src="jabil.svg" alt="Loading">
    </div>
</div>